import React, {useEffect, useState} from 'react';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import parse from 'html-react-parser';
import AddNotes from '../popups/AddNotes';
import DeleteItem from '../popups/DeleteItem';
import { convertUTCToPST } from '../Reusables/Function';


function EntityNotes(props) {
    const {page, entityId, showNotes, setShowNotes} = props;
    const navigate = useNavigate();
    const [notes, setNotes] = useState("");
    const [defaultNotes, setDefaultNotes] = useState("");
    const [notesList, setNotesList] = useState([]);
    const [isNoteAdded, setNodeAdded] = useState(false);
    const [notesId, setNotesId] = useState(null);
    const [deleteNotesId, setDeleteNotesId] = useState(null);
    const [trigger, setTrigger] = useState(false);

    const [showDeleteFile, setShowDeleteFile] = useState(false);
    const handleCloseDeletePopup = () => setShowDeleteFile(false);
    const handleShowDeletePopup = () => setShowDeleteFile(true);

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.GetDetailsWithToken(`/api/entity/${entityId}/noteslist`, accesstoken, (data) => {
                    if(data.status == 200) {
                        setNotesList(data.data.data);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [isNoteAdded, trigger])

    const handleEdit = (data) => {
        setShowNotes(true);
        setNotes(data.details);
        setNotesId(data.idEntityNotesRelation)
        setDefaultNotes(data.details)
    }

    const callDeleteNotesApi = () => {
        const URL = `/api/entity/notes/delete/${deleteNotesId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.DeleteDetails(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setTrigger(!trigger);
                        handleCloseDeletePopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const DeleteNotes = (e, id) => {
        e.stopPropagation();
        setDeleteNotesId(id);
        handleShowDeletePopup();
    }

    return (
        <div className='entity-notes-container'>
            {(showNotes) && 
                <AddNotes page={page} entityId={entityId} showNotes={showNotes} setShowNotes={setShowNotes} isNoteAdded={isNoteAdded}
                setNodeAdded={setNodeAdded} notes={notes} setNotes={setNotes} 
                setDefaultNotes={setDefaultNotes} defaultNotes={defaultNotes} notesId={notesId}/>
            }
            {(notesList.length > 0 || showNotes) ? 
                <div className='note-list-container'>
                    {notesList.length > 0 && notesList.map((item) => {
                        return(
                            <div className='notes-list-content'>
                                <div>
                                    <p className='message'>{parse(item.details)}</p>
                                </div>
                                <div className='user-details'>
                                    <div>
                                        <p className='user'>{item.user}</p>
                                    </div>
                                    <div>
                                        <p className='create-date'>{convertUTCToPST(item.createdTime + 'Z', "updates")}</p>
                                    </div>
                                    <div>
                                        <p className='edit' onClick={() => handleEdit(item)}>Edit</p>
                                        <p className='delete' onClick={(e) => DeleteNotes(e, item.idEntityNotesRelation)}>Delete</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div> : 
                <p className="no-result">No results found</p>
            }

            {/* Showing delete popup */}
            <DeleteItem show={showDeleteFile} handleClose={handleCloseDeletePopup} deleteApiCall={callDeleteNotesApi} enable={true}/>
        </div>
    );
}

export default EntityNotes;